import { applyFilters, doRequest } from "./helpers";

export default class MetaAdAccountService {
  static async list(filters = null, { suppressForbiddenModal } = {}) {
    let path = "/meta_ad_account/";
    path = applyFilters(filters, path);
    return doRequest("GET", path, { suppressForbiddenModal });
  }

  static async get(accountId) {
    return doRequest("GET", `/meta_ad_account/${accountId}`);
  }

  static async create(data) {
    return doRequest("POST", "/meta_ad_account/", { data });
  }

  static async update(accountId, data) {
    return doRequest("PUT", `/meta_ad_account/${accountId}`, { data });
  }

  static async delete(accountId) {
    return doRequest("DELETE", `/meta_ad_account/${accountId}`);
  }

  static async syncAll(accountId) {
    return doRequest("POST", `/meta_ad_account/${accountId}/sync/all`);
  }

  static async receiveSandbox(accountId) {
    return doRequest("POST", `/meta_ad_account/${accountId}/sandbox/receive`);
  }

  static async sendTestEvent(
    accountId,
    datasetId,
    testEventCode,
    eventName,
    accessToken,
    actionSource
  ) {
    return doRequest(
      "POST",
      `/meta_ad_account/${accountId}/datasets/${datasetId}/test_event`,
      {
        // The dataset token is a credential, so it travels in a header, never
        // in the request body.
        headers: accessToken ? { "X-Meta-Dataset-Token": accessToken } : {},
        data: {
          test_event_code: testEventCode,
          event_name: eventName,
          action_source: actionSource,
        },
      }
    );
  }
}
